import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear(); // Get current year

  return (
    <footer className="footer">
      
      <p>© Propertunity {currentYear}</p>
    </footer>
  );
}

export default Footer;
